export default __webpack_public_path__ + "04594337f948feb62ef4c78fd3ee1ae6.jpg";